import { gql } from '@apollo/client';

const UPDATE_USER_PHONE = gql`
  mutation UpdateUserProfile($input: UpdateUserProfileInput!) {
    updateUserProfileV2(input: $input) {
      personalInfo {
        contactInfo {
          phones {
            category # TODO(V2): This field is deprecated should be removed.
            phoneType
            extension
            number
            countryCode
          }
        }
      }
    }
  }
`;

export default UPDATE_USER_PHONE;
